export function formatDate(date){
  if(!date){
    return (new Date()).formatDate();
  } else if (date instanceof Date){
    return date.formatDate();
  } else if (typeof date === 'string'){
    return date;
  }
}